// Cascading country → state/province dataset for the Org Chart wallet form.
// Covers the major affiliate-business countries with their full state lists.
// Countries not in STATES_BY_COUNTRY fall back to a generic single option so
// the form still validates without forcing the admin to type free-text.

export const COUNTRIES = [
  "Argentina", "Australia", "Austria", "Bangladesh", "Belgium", "Brazil",
  "Canada", "Chile", "China", "Colombia", "Costa Rica", "Czech Republic",
  "Denmark", "Dominican Republic", "Ecuador", "Egypt", "Finland", "France",
  "Germany", "Ghana", "Greece", "Guatemala", "Honduras", "Hong Kong",
  "Hungary", "India", "Indonesia", "Ireland", "Israel", "Italy",
  "Jamaica", "Japan", "Kenya", "Malaysia", "Mexico", "Morocco",
  "Netherlands", "New Zealand", "Nigeria", "Norway", "Pakistan", "Panama",
  "Peru", "Philippines", "Poland", "Portugal", "Romania", "Russia",
  "Saudi Arabia", "Singapore", "South Africa", "South Korea", "Spain",
  "Sweden", "Switzerland", "Taiwan", "Thailand", "Trinidad and Tobago",
  "Turkey", "Ukraine", "United Arab Emirates", "United Kingdom",
  "United States", "Uruguay", "Venezuela", "Vietnam", "Other",
];

export const STATES_BY_COUNTRY = {
  "United States": [
    "Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado",
    "Connecticut", "Delaware", "District of Columbia", "Florida", "Georgia",
    "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa", "Kansas", "Kentucky",
    "Louisiana", "Maine", "Maryland", "Massachusetts", "Michigan", "Minnesota",
    "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire",
    "New Jersey", "New Mexico", "New York", "North Carolina", "North Dakota",
    "Ohio", "Oklahoma", "Oregon", "Pennsylvania", "Rhode Island",
    "South Carolina", "South Dakota", "Tennessee", "Texas", "Utah", "Vermont",
    "Virginia", "Washington", "West Virginia", "Wisconsin", "Wyoming",
    "Puerto Rico", "US Virgin Islands", "Guam", "American Samoa",
    "Northern Mariana Islands",
  ],
  "Canada": [
    "Alberta", "British Columbia", "Manitoba", "New Brunswick",
    "Newfoundland and Labrador", "Northwest Territories", "Nova Scotia",
    "Nunavut", "Ontario", "Prince Edward Island", "Quebec", "Saskatchewan",
    "Yukon",
  ],
  "Australia": [
    "Australian Capital Territory", "New South Wales", "Northern Territory",
    "Queensland", "South Australia", "Tasmania", "Victoria",
    "Western Australia",
  ],
  "United Kingdom": ["England", "Northern Ireland", "Scotland", "Wales"],
  "India": [
    "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh",
    "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand", "Karnataka",
    "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur", "Meghalaya", "Mizoram",
    "Nagaland", "Odisha", "Punjab", "Rajasthan", "Sikkim", "Tamil Nadu",
    "Telangana", "Tripura", "Uttar Pradesh", "Uttarakhand", "West Bengal",
    "Andaman and Nicobar Islands", "Chandigarh",
    "Dadra and Nagar Haveli and Daman and Diu", "Delhi", "Jammu and Kashmir",
    "Ladakh", "Lakshadweep", "Puducherry",
  ],
  "Germany": [
    "Baden-Württemberg", "Bavaria", "Berlin", "Brandenburg", "Bremen",
    "Hamburg", "Hesse", "Lower Saxony", "Mecklenburg-Vorpommern",
    "North Rhine-Westphalia", "Rhineland-Palatinate", "Saarland", "Saxony",
    "Saxony-Anhalt", "Schleswig-Holstein", "Thuringia",
  ],
  "Mexico": [
    "Aguascalientes", "Baja California", "Baja California Sur", "Campeche",
    "Chiapas", "Chihuahua", "Coahuila", "Colima", "Durango", "Guanajuato",
    "Guerrero", "Hidalgo", "Jalisco", "Mexico City", "Mexico State",
    "Michoacán", "Morelos", "Nayarit", "Nuevo León", "Oaxaca", "Puebla",
    "Querétaro", "Quintana Roo", "San Luis Potosí", "Sinaloa", "Sonora",
    "Tabasco", "Tamaulipas", "Tlaxcala", "Veracruz", "Yucatán", "Zacatecas",
  ],
  "Brazil": [
    "Acre", "Alagoas", "Amapá", "Amazonas", "Bahia", "Ceará",
    "Distrito Federal", "Espírito Santo", "Goiás", "Maranhão", "Mato Grosso",
    "Mato Grosso do Sul", "Minas Gerais", "Pará", "Paraíba", "Paraná",
    "Pernambuco", "Piauí", "Rio de Janeiro", "Rio Grande do Norte",
    "Rio Grande do Sul", "Rondônia", "Roraima", "Santa Catarina", "São Paulo",
    "Sergipe", "Tocantins",
  ],
  "France": [
    "Auvergne-Rhône-Alpes", "Bourgogne-Franche-Comté", "Brittany",
    "Centre-Val de Loire", "Corsica", "Grand Est", "Hauts-de-France",
    "Île-de-France", "Normandy", "Nouvelle-Aquitaine", "Occitanie",
    "Pays de la Loire", "Provence-Alpes-Côte d'Azur",
  ],
  "Italy": [
    "Abruzzo", "Aosta Valley", "Apulia", "Basilicata", "Calabria", "Campania",
    "Emilia-Romagna", "Friuli-Venezia Giulia", "Lazio", "Liguria", "Lombardy",
    "Marche", "Molise", "Piedmont", "Sardinia", "Sicily", "Trentino-South Tyrol",
    "Tuscany", "Umbria", "Veneto",
  ],
  "Spain": [
    "Andalusia", "Aragon", "Asturias", "Balearic Islands", "Basque Country",
    "Canary Islands", "Cantabria", "Castile and León", "Castile-La Mancha",
    "Catalonia", "Ceuta", "Community of Madrid", "Extremadura", "Galicia",
    "La Rioja", "Melilla", "Murcia", "Navarre", "Valencian Community",
  ],
  "Argentina": [
    "Buenos Aires", "Buenos Aires Province", "Catamarca", "Chaco", "Chubut",
    "Córdoba", "Corrientes", "Entre Ríos", "Formosa", "Jujuy", "La Pampa",
    "La Rioja", "Mendoza", "Misiones", "Neuquén", "Río Negro", "Salta",
    "San Juan", "San Luis", "Santa Cruz", "Santa Fe", "Santiago del Estero",
    "Tierra del Fuego", "Tucumán",
  ],
  "Colombia": [
    "Amazonas", "Antioquia", "Arauca", "Atlántico", "Bogotá", "Bolívar",
    "Boyacá", "Caldas", "Caquetá", "Casanare", "Cauca", "Cesar", "Chocó",
    "Córdoba", "Cundinamarca", "Guainía", "Guaviare", "Huila", "La Guajira",
    "Magdalena", "Meta", "Nariño", "Norte de Santander", "Putumayo", "Quindío",
    "Risaralda", "San Andrés y Providencia", "Santander", "Sucre", "Tolima",
    "Valle del Cauca", "Vaupés", "Vichada",
  ],
  "Indonesia": [
    "Aceh", "Bali", "Bangka Belitung Islands", "Banten", "Bengkulu",
    "Central Java", "Central Kalimantan", "Central Sulawesi", "East Java",
    "East Kalimantan", "East Nusa Tenggara", "Gorontalo", "Jakarta", "Jambi",
    "Lampung", "Maluku", "North Kalimantan", "North Maluku", "North Sulawesi",
    "North Sumatra", "Papua", "Riau", "Riau Islands", "South Kalimantan",
    "South Sulawesi", "South Sumatra", "Southeast Sulawesi", "West Java",
    "West Kalimantan", "West Nusa Tenggara", "West Papua", "West Sulawesi",
    "West Sumatra", "Yogyakarta",
  ],
  "Philippines": [
    "Abra", "Agusan del Norte", "Agusan del Sur", "Aklan", "Albay", "Antique",
    "Apayao", "Aurora", "Basilan", "Bataan", "Batanes", "Batangas", "Benguet",
    "Biliran", "Bohol", "Bukidnon", "Bulacan", "Cagayan", "Camarines Norte",
    "Camarines Sur", "Camiguin", "Capiz", "Catanduanes", "Cavite", "Cebu",
    "Cotabato", "Davao de Oro", "Davao del Norte", "Davao del Sur",
    "Davao Occidental", "Davao Oriental", "Dinagat Islands", "Eastern Samar",
    "Guimaras", "Ifugao", "Ilocos Norte", "Ilocos Sur", "Iloilo", "Isabela",
    "Kalinga", "La Union", "Laguna", "Lanao del Norte", "Lanao del Sur",
    "Leyte", "Maguindanao del Norte", "Maguindanao del Sur", "Marinduque",
    "Masbate", "Metro Manila", "Misamis Occidental", "Misamis Oriental",
    "Mountain Province", "Negros Occidental", "Negros Oriental",
    "Northern Samar", "Nueva Ecija", "Nueva Vizcaya", "Occidental Mindoro",
    "Oriental Mindoro", "Palawan", "Pampanga", "Pangasinan", "Quezon",
    "Quirino", "Rizal", "Romblon", "Samar", "Sarangani", "Siquijor",
    "Sorsogon", "South Cotabato", "Southern Leyte", "Sultan Kudarat", "Sulu",
    "Surigao del Norte", "Surigao del Sur", "Tarlac", "Tawi-Tawi", "Zambales",
    "Zamboanga del Norte", "Zamboanga del Sur", "Zamboanga Sibugay",
  ],
  "Japan": [
    "Aichi", "Akita", "Aomori", "Chiba", "Ehime", "Fukui", "Fukuoka",
    "Fukushima", "Gifu", "Gunma", "Hiroshima", "Hokkaido", "Hyogo", "Ibaraki",
    "Ishikawa", "Iwate", "Kagawa", "Kagoshima", "Kanagawa", "Kochi", "Kumamoto",
    "Kyoto", "Mie", "Miyagi", "Miyazaki", "Nagano", "Nagasaki", "Nara",
    "Niigata", "Oita", "Okayama", "Okinawa", "Osaka", "Saga", "Saitama",
    "Shiga", "Shimane", "Shizuoka", "Tochigi", "Tokushima", "Tokyo", "Tottori",
    "Toyama", "Wakayama", "Yamagata", "Yamaguchi", "Yamanashi",
  ],
  "South Korea": [
    "Busan", "Chungcheongbuk-do", "Chungcheongnam-do", "Daegu", "Daejeon",
    "Gangwon-do", "Gwangju", "Gyeonggi-do", "Gyeongsangbuk-do",
    "Gyeongsangnam-do", "Incheon", "Jeju", "Jeollabuk-do", "Jeollanam-do",
    "Sejong", "Seoul", "Ulsan",
  ],
  "China": [
    "Anhui", "Beijing", "Chongqing", "Fujian", "Gansu", "Guangdong", "Guangxi",
    "Guizhou", "Hainan", "Hebei", "Heilongjiang", "Henan", "Hong Kong", "Hubei",
    "Hunan", "Inner Mongolia", "Jiangsu", "Jiangxi", "Jilin", "Liaoning",
    "Macau", "Ningxia", "Qinghai", "Shaanxi", "Shandong", "Shanghai", "Shanxi",
    "Sichuan", "Tianjin", "Tibet", "Xinjiang", "Yunnan", "Zhejiang",
  ],
  "Malaysia": [
    "Johor", "Kedah", "Kelantan", "Kuala Lumpur", "Labuan", "Malacca",
    "Negeri Sembilan", "Pahang", "Penang", "Perak", "Perlis", "Putrajaya",
    "Sabah", "Sarawak", "Selangor", "Terengganu",
  ],
  "Pakistan": [
    "Azad Kashmir", "Balochistan", "Federal Capital Territory",
    "Gilgit-Baltistan", "Khyber Pakhtunkhwa", "Punjab", "Sindh",
  ],
  "Bangladesh": [
    "Barisal", "Chittagong", "Dhaka", "Khulna", "Mymensingh", "Rajshahi",
    "Rangpur", "Sylhet",
  ],
  "South Africa": [
    "Eastern Cape", "Free State", "Gauteng", "KwaZulu-Natal", "Limpopo",
    "Mpumalanga", "North West", "Northern Cape", "Western Cape",
  ],
  "Nigeria": [
    "Abia", "Abuja", "Adamawa", "Akwa Ibom", "Anambra", "Bauchi", "Bayelsa",
    "Benue", "Borno", "Cross River", "Delta", "Ebonyi", "Edo", "Ekiti",
    "Enugu", "Gombe", "Imo", "Jigawa", "Kaduna", "Kano", "Katsina", "Kebbi",
    "Kogi", "Kwara", "Lagos", "Nasarawa", "Niger", "Ogun", "Ondo", "Osun",
    "Oyo", "Plateau", "Rivers", "Sokoto", "Taraba", "Yobe", "Zamfara",
  ],
  "United Arab Emirates": [
    "Abu Dhabi", "Ajman", "Dubai", "Fujairah", "Ras Al Khaimah", "Sharjah",
    "Umm Al Quwain",
  ],
  "Saudi Arabia": [
    "Al Bahah", "Al Jawf", "Al Madinah", "Al Qassim", "Asir", "Eastern Province",
    "Ha'il", "Jazan", "Makkah", "Najran", "Northern Borders", "Riyadh", "Tabuk",
  ],
  "Russia": [
    "Adygea", "Altai Krai", "Altai Republic", "Amur Oblast", "Arkhangelsk",
    "Astrakhan Oblast", "Bashkortostan", "Belgorod Oblast", "Bryansk Oblast",
    "Buryatia", "Chechen Republic", "Chelyabinsk Oblast", "Chukotka",
    "Chuvashia", "Dagestan", "Ingushetia", "Irkutsk Oblast", "Ivanovo Oblast",
    "Jewish Autonomous Oblast", "Kabardino-Balkaria", "Kaliningrad Oblast",
    "Kalmykia", "Kaluga Oblast", "Kamchatka Krai", "Karachay-Cherkessia",
    "Karelia", "Kemerovo Oblast", "Khabarovsk Krai", "Khakassia",
    "Khanty-Mansi", "Kirov Oblast", "Komi Republic", "Kostroma Oblast",
    "Krasnodar Krai", "Krasnoyarsk Krai", "Kurgan Oblast", "Kursk Oblast",
    "Leningrad Oblast", "Lipetsk Oblast", "Magadan Oblast", "Mari El",
    "Mordovia", "Moscow", "Moscow Oblast", "Murmansk Oblast", "Nenets",
    "Nizhny Novgorod Oblast", "North Ossetia", "Novgorod Oblast",
    "Novosibirsk Oblast", "Omsk Oblast", "Orenburg Oblast", "Oryol Oblast",
    "Penza Oblast", "Perm Krai", "Primorsky Krai", "Pskov Oblast", "Rostov Oblast",
    "Ryazan Oblast", "Saint Petersburg", "Sakha Republic", "Sakhalin Oblast",
    "Samara Oblast", "Saratov Oblast", "Smolensk Oblast", "Stavropol Krai",
    "Sverdlovsk Oblast", "Tambov Oblast", "Tatarstan", "Tomsk Oblast",
    "Tula Oblast", "Tver Oblast", "Tyumen Oblast", "Tyva", "Udmurtia",
    "Ulyanovsk Oblast", "Vladimir Oblast", "Volgograd Oblast", "Vologda Oblast",
    "Voronezh Oblast", "Yamalo-Nenets", "Yaroslavl Oblast", "Zabaykalsky Krai",
  ],
  "New Zealand": [
    "Auckland", "Bay of Plenty", "Canterbury", "Gisborne", "Hawke's Bay",
    "Manawatū-Whanganui", "Marlborough", "Nelson", "Northland", "Otago",
    "Southland", "Taranaki", "Tasman", "Waikato", "Wellington", "West Coast",
  ],
  "Switzerland": [
    "Aargau", "Appenzell Ausserrhoden", "Appenzell Innerrhoden",
    "Basel-Landschaft", "Basel-Stadt", "Bern", "Fribourg", "Geneva", "Glarus",
    "Graubünden", "Jura", "Lucerne", "Neuchâtel", "Nidwalden", "Obwalden",
    "Schaffhausen", "Schwyz", "Solothurn", "St. Gallen", "Thurgau", "Ticino",
    "Uri", "Valais", "Vaud", "Zug", "Zürich",
  ],
  "Ireland": [
    "Carlow", "Cavan", "Clare", "Cork", "Donegal", "Dublin", "Galway", "Kerry",
    "Kildare", "Kilkenny", "Laois", "Leitrim", "Limerick", "Longford", "Louth",
    "Mayo", "Meath", "Monaghan", "Offaly", "Roscommon", "Sligo", "Tipperary",
    "Waterford", "Westmeath", "Wexford", "Wicklow",
  ],
  "Netherlands": [
    "Drenthe", "Flevoland", "Friesland", "Gelderland", "Groningen", "Limburg",
    "North Brabant", "North Holland", "Overijssel", "South Holland", "Utrecht",
    "Zeeland",
  ],
};

const GENERIC_FALLBACK = ["Capital region", "Other"];

/**
 * Return the list of states/provinces for the given country.
 * Falls back to a generic two-option list when the country has no detailed map.
 */
export function getStatesFor(country) {
  if (!country) return [];
  return STATES_BY_COUNTRY[country] || GENERIC_FALLBACK;
}
